<section class="position-relative header-section">
  <app-small-header
    textColor="#fff"
    [homePage]="true"
    [showSearchField]="true"
  ></app-small-header>
</section>

<div class="container pb-1">
  <section class="mt-5">
    <div class="py-1 h-100 px-0">
      @if (primaryVideoUrl || visibleImages?.length) {
        <section id="gallery-section" class="my-3 gallary-banner-top">
          <div class="gallery-wide-grid">
            <div
              class="gallery-tile video"
              role="button"
              tabindex="0"
              (click)="openAllGalleryModal()"
              (keydown.enter)="openAllGalleryModal()"
            >
              @if (primaryVideoUrl) {
                <!-- <div class="video-play-icon">
              <i class="fa fa-play"></i>
            </div> -->

                <video
                  [src]="primaryVideoSafeUrl"
                  [muted]="true"
                  autoplay
                  loop
                  playsinline
                  class="preview-video"
                ></video>
              } @else if (visibleImages?.length) {
                <div
                  class="fallback-image"
                  [style.backgroundImage]="'url(' + visibleImages[0] + ')'"
                ></div>
              }
            </div>

            @if (visibleImages?.length) {
              <div class="gallery-images-grid">
                @for (
                  img of visibleImages.slice(0, isMobile ? 4 : 6);
                  track img;
                  let i = $index
                ) {
                  <div
                    class="gallery-tile image"
                    role="button"
                    tabindex="0"
                    (click)="openAllGalleryModal()"
                    (keydown.enter)="openAllGalleryModal()"
                    [style.backgroundImage]="'url(' + img + ')'"
                  >
                    @if (i === (isMobile ? 4 : 6) - 1 && overflowCount > 0) {
                      <div class="more-overlay">+{{ overflowCount }} More</div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </section>
      }
    </div>
  </section>

  <div *ngIf="formErrorMessage" class="form-error-banner" id="form-error">
    <mat-icon class="error-icon">error</mat-icon>
    <span>{{ formErrorMessage }}</span>
  </div>

  <section class="search-bar px-2 py-3">
    <form [formGroup]="form">
      <div class="container">
        <div class="search-grid">
          <div class="search-item">
            <div class="search-input-container position-relative d-flex">
              <ng-select
                [bindValue]="'_id'"
                [bindLabel]="'name'"
                [items]="hotelList"
                class="w-100 custom-destination"
                [placeholder]="'Select A Hotel'"
                formControlName="hotelItem"
                [required]="true"
                (change)="onHotelChange($event)"
              >
              </ng-select>
            </div>
          </div>

          <div
            class="search-item position-relative"
            role="button"
            (click)="openCalendar($event)"
          >
            <!-- <label class="search-label">CHECKIN - CHECKOUT</label> -->
            <div class="search-value">
              {{ checkIn ? (checkIn | date: "MMM d, y") : "Select Date" }} |
              {{ checkOut ? (checkOut | date: "MMM d, y") : "Select Date" }}
            </div>
          </div>
          @if (isDropdownVisible) {
            <div
              class="date-dropdown mt-1"
              (click)="$event.stopPropagation()"
              [ngStyle]="{
                top: dropdownPosition.top,
                left: dropdownPosition.left,
                'overflow-y': dropdownPosition.overflowY,
              }"
            >
              <ng-container
                [ngTemplateOutlet]="bottomSheetTemplate"
              ></ng-container>
            </div>
          }

          <div class="search-item">
            <!-- <label class="search-label">GUEST & ROOMS</label> -->
            <div class="search-value" (click)="openAdultDropdown($event)">
              {{
                dynamicPlaceholder
                  ? dynamicPlaceholder
                  : "1 Room | 2 Adults | 0 Children"
              }}
            </div>
          </div>
          @if (isAdultDropdownVisible) {
            <div
              class="date-dropdown mt-1"
              (click)="$event.stopPropagation()"
              [ngStyle]="{
                top: dropdownPosition.top,
                left: dropdownPosition.left,
                width: dropdownPosition.width,
              }"
            >
              <ng-container
                [ngTemplateOutlet]="adultBottomSheetTemplate"
              ></ng-container>
            </div>
          }

          <div class="search-action">
            <button class="btn-update" type="button" (click)="onSearch()">
              <i class="fa fa-search text-white me-2"></i> Search
            </button>
          </div>
        </div>
      </div>
    </form>
  </section>

  <div
    id="overview-section"
    class="hotel-header d-flex justify-content-between align-items-center p-3 mt-3 mb-3"
  >
    <div>
      <div class="d-flex align-items-center gap-2">
        <h5 class="hotel-title mb-0">{{ hotelTitle }}</h5>
        <!-- <div class="d-flex gap-1 mt-1">
            @for((star of [1,1,1,1,1]); let i=$index; track i) {
            <i class="fas fa-star star-icon"></i>
            }
          </div> -->
      </div>
      <div class="hotel-address mt-1">
        {{ hotelData?.address }}
      </div>
    </div>
  </div>

  <div class="rating-card p-2 mb-3">
    <div class="rating-header">
      <div class="score-pill">{{ ratingScore }}</div>

      <div class="rating-meta">
        <div class="rating-title">{{ ratingLabel }}</div>
        <div class="rating-reviews">{{ totalReviews | number }} reviews</div>
      </div>
    </div>

    <div class="rating-tags">
      @for (t of ratingTags; track t) {
        <span class="tag">{{ t }}</span>
      }
    </div>
  </div>

  <!-- <div
    class="sticky-top mt-0 mb-3 py-3 px-3 hotel-card hotel-desc-nav d-flex justify-content-between align-items-center"
  >
    <app-tab [tabs]="tabs" [hScroll]="true"> </app-tab>
  </div> -->

  <section class="hotel-card my-2 mb-5" id="about-section">
    <h6 class="about-title px-3 py-3">About The Hotel</h6>

    <div class="px-3 py-2">
      <div
        class="about-text html-content"
        [class.expanded]="isExpanded"
        [innerHTML]="hotelDescriptionHtml"
      ></div>

      <a href="javascript:void(0)" class="toggle-link" (click)="toggleExpand()">
        {{ isExpanded ? "View Less" : "View More" }}
        <i
          class="fas"
          [ngClass]="isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
      </a>
    </div>
  </section>

  <div class="row gx-0">
    <section id="rooms-section">
      <div id="availability-scroll"></div>

      @if (hotelData) {
        <!-- <app-rooms
          [rooms]="hotelData?.rooms"
          (book)="goToAvailabilityPage($event.room, $event.event)"
        >
        </app-rooms> -->
        <app-hotel-room
          [rooms]="hotelData?.rooms"
          (book)="goToAvailabilityPage($event.room, $event.event)"
        >
        </app-hotel-room>
      }
    </section>
    <section id="location-section">
      <div class="map">
        <iframe
          width="100%"
          height="300"
          [src]="safeMapUrl"
          style="border: 0"
          allowfullscreen
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        >
        </iframe>
      </div>

      <div class="attractions text-start ps-3 hotel-card pt-2">
        <h5 class="explore-title pt-2">Explore Nearby Places</h5>
        <div class="explore-divider-wrapper">
          <hr class="explore-title-border" />
        </div>

        <div class="row area-list word-break">
          <div class="col-md-6 mb-3" *ngFor="let attr of attractions">
            <div class="d-flex flex-column">
              <span class="attraction-name">{{ attr.name }}</span>
              <span class="distance" *ngIf="attr.distance">
                {{ attr.distance }} km away
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #bottomSheetTemplate>
  <div class="d-grid p-3">
    <app-dual-calender
      [calendarMode]="isMobile ? 'single' : 'dual'"
      [minDate]="minFor()"
      [startDate]="checkIn ?? null"
      [endDate]="checkOut"
      (dateRangeSelected)="onSelectionChange($event)"
    >
    </app-dual-calender>
  </div>
</ng-template>

<ng-template #adultBottomSheetTemplate>
  <app-room-guest-menu
    [rooms]="roomGuests"
    [roomMin]="roomMin"
    [roomMax]="roomMax"
    [adultMin]="adultMin"
    [adultMax]="adultMax"
    [childMin]="childMin"
    (apply)="onGuestApply($event)"
  ></app-room-guest-menu>
</ng-template>

<div
  class="video-overlay"
  *ngIf="showVideoOverlay"
  (click)="closeInlineVideo()"
>
  <div class="video-overlay__inner" (click)="$event.stopPropagation()">
    <button class="video-overlay__close" (click)="closeInlineVideo()">
      &times;
    </button>

    <video
      id="hotel-inline-video"
      width="100%"
      controls
      autoplay
      muted
      playsinline
      [poster]="primaryVideoPoster"
      style="
        max-height: 80vh;
        background: #000;
        outline: none;
        border-radius: 8px;
      "
    >
      <source [src]="primaryVideoSafeUrl || ''" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</div>

<div
  class="app-loader-overlay"
  *ngIf="loading"
  aria-live="polite"
  aria-busy="true"
>
  <mat-progress-spinner
    mode="indeterminate"
    diameter="56"
  ></mat-progress-spinner>
  <div class="loader-text">Loading…</div>
</div>

<div
  *ngIf="isGalleryModalOpen"
  class="gallery-modal-backdrop"
  (click)="closeGalleryModal()"
></div>
<div
  *ngIf="isGalleryModalOpen"
  class="gallery-modal"
  role="dialog"
  aria-modal="true"
>
  <div class="gallery-modal__header">
    <button
      type="button"
      class="gallery-modal__back"
      (click)="closeGalleryModal()"
    >
      <i class="fa-solid fa-arrow-left-long"></i>
    </button>
    <div class="gallery-modal__tabs"></div>

    <button
      type="button"
      class="gallery-modal__close"
      (click)="closeGalleryModal()"
    >
      &times;
    </button>
  </div>

  <div class="gallery-modal__body" (click)="$event.stopPropagation()">
    <app-hotel-gallery
      [hotelSlug]="hotelSlug"
      [tag]="galleryModalTag"
      [categories]="hotelData?.galleryInfo"
    ></app-hotel-gallery>
  </div>
</div>
<app-scroll-to-top></app-scroll-to-top>

@if (showClearCartConfirm) {
  <div class="confirm-backdrop"></div>

  <div class="confirm-modal" role="dialog" aria-modal="true">
    <div class="confirm-header">
      <div class="confirm-title">Alert</div>
      <button type="button" class="confirm-close" (click)="onClearCartCancel()">
        ×
      </button>
    </div>

    <div class="confirm-body">
      THIS ACTION WILL RESULT IN LOSS OF ALL PREVIOUS INFORMATION
    </div>

    <div class="confirm-actions">
      <button type="button" class="btn-confirm-ok" (click)="onClearCartOk()">
        OK
      </button>

      <button
        type="button"
        class="btn-confirm-cancel"
        (click)="onClearCartCancel()"
      >
        CANCEL
      </button>
    </div>
  </div>
}
